import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import { applyInitialLang } from "./i18n/lang.ts";
import "./theme.css";

/*
 * Язык ставится на <html> ДО первого рендера: по атрибуту `lang` браузер
 * подбирает переносы и начертания, а `useThemeTick` следит именно за
 * атрибутом — так графики перерисовываются на смену языка тем же
 * механизмом, что и на смену темы.
 */
applyInitialLang();

const host = document.getElementById("root");
if (!host) throw new Error("#root not found");
createRoot(host).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
